<template>
  <div class="block" v-if="contact !== null">
    <!-- Area  -->
    <div class="form-item py-5 d-flex">
      <div class=" w-240px mr-5">
        <h4>Area</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <SimpleSelectWithSearchInput
          buttonPlaceholder="請選擇Area"
          isOnlyShowButtonPlaceholder="true"
          buttonWidth="248px"
          modalWidth="248px"
          :options="areaOptions"
          :selectedValue.sync="contact.area"
        ></SimpleSelectWithSearchInput>
      </div>
    </div>
    <!-- Location  -->
    <label class="form-item py-5 d-flex">
      <div class=" w-240px mr-5">
        <h4>Location</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="contact.location"
          outlined
          placeholder="請輸入Location"
          dense
        ></v-text-field>
      </div>
    </label>
    <!-- Address  -->
    <label class="form-item py-5 d-flex">
      <div class=" w-240px mr-5">
        <h4>Address</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="contact.address"
          outlined
          placeholder="請輸入Address"
          dense
        ></v-text-field>
      </div>
    </label>
    <!-- Tel.  -->
    <label class="form-item py-5 d-flex">
      <div class=" w-240px mr-5">
        <h4>Tel.</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="contact.tel"
          outlined
          placeholder="請輸入Tel"
          dense
        ></v-text-field>
      </div>
    </label>
    <!-- Email  -->
    <label class="form-item py-5 d-flex">
      <div class=" w-240px mr-5">
        <h4>Email</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="contact.email"
          outlined
          placeholder="請輸入Email"
          dense
        ></v-text-field>
      </div>
    </label>
    <!-- Email  -->
    <label class="form-item py-5 d-flex">
      <div class=" w-240px mr-5">
        <h4>URL</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="contact.url"
          outlined
          placeholder="請輸入URL"
          dense
        ></v-text-field>
      </div>
    </label>
    <!-- Email  -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4 class="mb-2">Image</h4>
        <div class="h5 ink-02-medium--text">
          顯示於聯絡我們頁面 <br />
          建議尺寸：700px * 300px <br />
          檔案大小限制：&lt; 1 MB
        </div>
      </div>
      <div class="flex-grow-1 flex-basis-0">
        <ImgUploader
          :imageUrl.sync="contact.image"
          dir="contact"></ImgUploader>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  components: {
    SimpleSelectWithSearchInput,
    ImgUploader,
  },
  data: () => ({
    area: '',
    location: '',
    address: '',
    tel: '',
    email: '',
  }),
  computed: {
    ...mapState('contact', ['contact', 'areaOptions']),
  },
};
</script>

<style></style>
